import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { infiniteQueryOptions } from '@tanstack/react-query';
import { IUser } from 'types/user';

export interface OrganizationUsersQueryParams {
    page?: never;
    page_size?: number;
    search_value?: string;
}

const infiniteOrganizationUsersQueryOptions = (
    organizationId: string,
    params: OrganizationUsersQueryParams = {},
) => infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: ['InfiniteOrganizationUsers', organizationId, params] satisfies readonly unknown[],
    queryFn: async ({ pageParam }) => {
        const response = await axiosInstance.get<IUser[]>(
            API_ENDPOINTS.ORGANIZATION.USERS(organizationId), {
                params: {
                    page: pageParam,
                    ...params,
                },
            },
        );
        return response.data;
    },
    getNextPageParam: () => undefined,
    // Will be changing this to a paginated endpoint, so just returning undefined for now
    // getNextPageParam: (lastPage, _allPages, lastPageParam) => (lastPage.next ? lastPageParam + 1 : null),
});

export default infiniteOrganizationUsersQueryOptions;
